// ============================================================================
// CASE OPPOSITE PARTY SERVICE — Phase 9b-2
// ============================================================================

import { get, post, put, del } from '../client/axiosClient';
import { caseOppositePartyEndpoints } from '../endpoints/caseOppositeParty.endpoints';
import type { ApiResponse, EmptyResponse, ID } from '../types';
import type {
  CaseOppositeParty,
  CreateCaseOppositePartyRequest,
  UpdateCaseOppositePartyRequest,
} from '../types/caseOppositeParty.types';

class CaseOppositePartyService {
  async getByCase(caseId: ID): Promise<ApiResponse<CaseOppositeParty[]>> {
    const response = await get<ApiResponse<CaseOppositeParty[]>>(
      caseOppositePartyEndpoints.byCase(caseId),
    );
    return response.data;
  }

  async getById(id: ID): Promise<ApiResponse<CaseOppositeParty>> {
    const response = await get<ApiResponse<CaseOppositeParty>>(
      caseOppositePartyEndpoints.getById(id),
    );
    return response.data;
  }

  async create(data: CreateCaseOppositePartyRequest): Promise<ApiResponse<CaseOppositeParty>> {
    const response = await post<ApiResponse<CaseOppositeParty>>(
      caseOppositePartyEndpoints.create(),
      data,
    );
    return response.data;
  }

  async update(id: ID, data: UpdateCaseOppositePartyRequest): Promise<ApiResponse<CaseOppositeParty>> {
    const response = await put<ApiResponse<CaseOppositeParty>>(
      caseOppositePartyEndpoints.update(id),
      data,
    );
    return response.data;
  }

  async delete(id: ID): Promise<EmptyResponse> {
    const response = await del<EmptyResponse>(caseOppositePartyEndpoints.delete(id));
    return response.data;
  }
}

export const caseOppositePartyService = new CaseOppositePartyService();
export default caseOppositePartyService;
